var React = require('react');

function Fail (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"1.4834","y":"0.161133","width":"12.0437","height":"1.64232","rx":"0.821159","transform":"rotate(45 1.4834 0.161133)","fill":"#DE202C","key":0}),React.createElement("rect",{"x":"0.322266","y":"8.67725","width":"12.0437","height":"1.64232","rx":"0.821159","transform":"rotate(-45 0.322266 8.67725)","fill":"#DE202C","key":1})]);
}

Fail.defaultProps = {"width":"10","height":"10","viewBox":"0 0 10 10","fill":"none"};

module.exports = Fail;

Fail.default = Fail;
